<template>
    <transition name="el-zoom-in-top">
        <div class="content-wrapper">
            <!-- Content Header (Page header) -->
            <section class="content-header">
                <!-- <h1>Blank Page<small>It's all start from here <i class="ti-heart"></i><i class="ti-export"></i><i class="ti-printer"></i></small></h1> -->
                <ol class="breadcrumb">
                    <li>
                        <router-link to="/"> <i class="ti-home"></i></router-link>
                    </li>
                    <li><a href="#">Common Page</a></li>
                    <li class="active">Login Page</li>
                </ol>
            </section>
            <!-- Main content -->
            <section class="content">
              <div class="box">

              </div>

                <!-- <el-dialog title="Login" :visible.sync="dialogVisible" :before-close="handleClose" v-loading="loadingModalLogin">
                    <div class="account-box">
                        <form role="form">
                            <div class="form-group"> <a href="#" class="pull-right label-forgot">Forgot email?</a>
                                <label for="inputUsernameEmail">Username</label>
                                <input type="text" id="inputUsernameEmail" class="form-control" v-model="username"> </div>
                            <div class="form-group"> <a href="#" class="pull-right label-forgot">Forgot password?</a>
                                <label for="inputPassword">Password</label>
                                <input type="password" id="inputPassword" class="form-control" v-model="pass"> </div>
                            <div class="checkbox pull-left">
                                <label>
                                    <input type="checkbox">Remember me</label>
                            </div>
                            <button class="btn btn btn-primary pull-right" @click="confirmLogin()">Log In</button>
                        </form>
                    </div>
                </el-dialog> -->

                <el-dialog id="dialog_login" title="" :visible.sync="dialogVisible" v-loading="loadingModalLogin" :before-close="handleClose" :fullscreen="fullscreen" center>
                  <el-row>
                    <el-col :xs="5" :sm="6" :md="7" :lg="9" :xl="10" class="grid-content"></el-col>
                    <el-col :align="middle" :justify="center" class="grid-content" :xs="14" :sm="12" :md="10" :lg="6" :xl="4">
                      <div >
                        <div style="text-align: center;"><img src="static/img/logo_hisana.png" width="50%"></div>
                        <br>
                        <el-form :model="form1">
                          <el-form-item label="Username">
                            <el-input v-model="form1.username"></el-input>
                          </el-form-item>
                          <el-form-item label="Password">
                            <el-input type="password" v-model="form1.pass" @keyup.enter.native="confirmLogin()"></el-input>
                          </el-form-item>
                        </el-form>
                        <div :span="24" style="text-align: center;"> <el-button type="primary" @click="confirmLogin()" round>Log In</el-button></div>
                      </div>
                    </el-col>
                    <el-col :xs="5" :sm="6" :md="7" :lg="9" :xl="10" class="grid-content"></el-col>
                  </el-row>
                </el-dialog>
            </section>
            <!-- /.content -->
        </div>
    </transition>
</template>
<script>
    import Vue from 'Vue'
    import VueResource from 'vue-resource'
    import VueCookie from 'vue-cookie'

    import jsonUrl from '../../../assets/url.json'

    // import axios from 'axios'
    import https from 'https'
    // import VueJsonp from 'vue-jsonp'
    // Vue.use(VueJsonp)

    // import VueAxios from 'vue-axios'

    // Vue.use(VueAxios, axios)

    Vue.use(VueResource)
    Vue.use(VueCookie)

    export default {
      data: function () {
        return {
          dialogVisible: true,
          username: '',
          pass: '',
          loadingModalLogin: false,
          form1: {
            username: '',
            pass: ''
          },
          fullscreen: true
        }
      },
      methods: {
        handleClose: function (done) {
          // console.log('ok1')
          this.$confirm('Silahkan masuk terlebih dahulu', 'Warning', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning'
          })
        },
        confirmLogin: function () {
          this.loadingModalLogin = true
          var url = Vue.cookie.get('url') + '/' + jsonUrl.session
          var auth = btoa(this.form1.username + ':' + this.form1.pass)
          const httpsAgent = new https.Agent({ rejectUnauthorized: false })

          process.env.NODE_TLS_REJECT_UNAUTHORIZED = '0'

          Vue.http.get(url, {httpsAgent: httpsAgent, mode: 'no-cors', headers: {'Content-Type': 'application/json', 'Authorization': auth}}).then(response => {
            this.loadingModalLogin = false

            try {
              if (typeof response.data.sessionExpired === 'string') {
                if (response.data.sessionId !== null && response.data.sessionId !== '') {
                  // Vue.cookie.set('session', response.data.sessionId.substring(1, 4000))
                  // Vue.cookie.set('username', response.data.username)
                  // Vue.cookie.set('level', response.data.level)
                  // Vue.cookie.set('kodeLevel', response.data.kodeLevel)
                  // Vue.cookie.set('kodeToko', response.data.kodeToko)
                  // Vue.cookie.set('login', true)

                  localStorage.session = response.data.sessionId
                  localStorage.username = response.data.username
                  localStorage.level = response.data.level
                  localStorage.kodeLevel = response.data.kodeLevel
                  // localStorage.kodeLevelInt = response.data.kodeLevel.match(/\d+/)[0]
                  localStorage.kodeToko = response.data.kodeToko
                  localStorage.prefix = response.data.prefix
                  localStorage.login = true

                  if (response.data.username === 'BOD') {
                    this.$router.push('penjualan')
                  } else if (response.data.level === 'ADMIN AREA') {
                    this.$router.push('toko_pegawai')
                  } else {
                    this.$router.push('toko_dashboard')
                  }
                  // this.$router.go(-1)
                  // this.$router.replace('/')
                }
              } else {
                console.log('yah')
                this.$router.push('/login')
              }
            } catch (e) {
              console.log('disableFor', e)
              this.$router.push('/login')
            }
          }, response => {
            // error callback
          })

          // axios.defaults.withCredentials = true

          // axios.get(url, {httpsAgent: httpsAgent, mode: 'no-cors', headers: {'Content-Type': 'application/json', 'Authorization': auth}}).then((response) => {
          //   this.loadingModalLogin = false
          //   // console.log(response.data.sessionId)
          //   if (response.data.sessionId !== null) {
          //     Vue.cookie.set('session', response.data.sessionId, '1h')
          //     Vue.cookie.set('login', true, 1)
          //     this.$router.go(-1)
          //   }
          // })

          // Vue.jsonp(url, {headers: {'Content-Type': 'application/json', 'Authorization': auth}}).then(json => {
          //   // Success.
          //   console.log(json)
          // }).catch(err => {
          //   // Failed.
          //   console.log(err)
          // })
        }
      },
      mounted () {
        // DEV
        // Vue.cookie.set('url', 'http://117.53.46.24:1112')
        // STAGGING
        // Vue.cookie.set('url', 'http://117.53.45.239:1112')
        // Vue.cookie.set('url', 'http://117.53.47.96:1112')
        // Vue.cookie.set('url', 'https://117.53.47.96:8989')
        Vue.cookie.set('url', 'http://103.41.205.175:1112')
        // var url = jsonUrl.geturl
        // Vue.cookie.set('level', '')

        // Vue.http.get(url).then(response => {
        //   Vue.cookie.set('url', response.body)
        // }, response => {
        //   // error callback
        // })
      }
    }
</script>



// WEBPACK FOOTER //
// Login.vue?ef874e5a